import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { AuthContext } from '../../providers/AuthProvider'

const Component = ({ children }: { children: JSX.Element }) => {
  let { isAuthenticated } = React.useContext(AuthContext)
  let location = useLocation()

  // console.log('RequireAuth Component', { isAuthenticated })

  if (!isAuthenticated) {
    // console.log('No Authenticated - RequireAuth Component', { isAuthenticated })
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to='/sign-in' replace state={{ from: location }} />
  }

  return children
}

export default Component
